type Props = { fill?: string };

const ClockIcon = ({ fill = "#946800" }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_13036_66293)">
        <path
          d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259969 4.80026 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40353 1.75736 10.2426C2.59648 11.0818 3.66558 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0892 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C11.9953 4.41016 11.3616 2.8868 10.2374 1.7626C9.11321 0.638414 7.58984 0.00474818 6 0V0ZM6 10.5C5.10999 10.5 4.23996 10.2361 3.49994 9.74161C2.75992 9.24715 2.18314 8.54434 1.84254 7.72208C1.50195 6.89981 1.41284 5.99501 1.58647 5.12209C1.7601 4.24918 2.18869 3.44736 2.81802 2.81802C3.44736 2.18868 4.24918 1.7601 5.1221 1.58647C5.99501 1.41283 6.89981 1.50195 7.72208 1.84254C8.54435 2.18314 9.24715 2.75991 9.74162 3.49993C10.2361 4.23996 10.5 5.10998 10.5 6C10.4964 7.19238 10.0212 8.3349 9.17805 9.17805C8.33491 10.0212 7.19238 10.4964 6 10.5Z"
          fill={fill ?? "#3B3F42"}
        />
        <path
          d="M8.625 5.25H6.75V3.375C6.75 3.17609 6.67098 2.98532 6.53033 2.84467C6.38968 2.70402 6.19891 2.625 6 2.625C5.80109 2.625 5.61032 2.70402 5.46967 2.84467C5.32902 2.98532 5.25 3.17609 5.25 3.375V6C5.25 6.19891 5.32902 6.38968 5.46967 6.53033C5.61032 6.67098 5.80109 6.75 6 6.75H8.625C8.82391 6.75 9.01468 6.67098 9.15533 6.53033C9.29598 6.38968 9.375 6.19891 9.375 6C9.375 5.80109 9.29598 5.61032 9.15533 5.46967C9.01468 5.32902 8.82391 5.25 8.625 5.25Z"
          fill={fill ?? "#3B3F42"}
        />
      </g>
    </svg>
  );
};

export default ClockIcon;
